export const serverBaseUrl = "https://api.aliceandbot.com";
